import { Skeleton, Card, Col, Row, Avatar } from "antd";
import { FC } from "react";


interface SkeletonCardProps {
  count: number;
  loading: boolean;
  children: any;
  customGutter: any;
  rowCount?: number;
}

const AdvertListViewSkelton: FC<SkeletonCardProps> = ({
  count = 1,
  loading = false,
  children,
  customGutter,
  rowCount = 1,
}) => {
  if (!loading) return children;

  return (
    <>
      {[...Array(rowCount)].map((_, rowIndex) => (
        <Row gutter={customGutter} key={rowIndex}>
          {[...Array(count)].map((_, colIndex) => {
            const keyIndex = rowIndex * count + colIndex;
            return (
              <Col xs={24} key={keyIndex}>
                <Row gutter={[10, 0]}>
                  <Col xs={24} md={12} lg={6}>
                    <Card className="rounded-bl-md rounded-br-md mb-4 !w-full">
                      <div className="!bg-[#f0f0f0] !w-full !h-[200px] !flex justify-center items-center ">
                        <div className="!w-[70px] !h-[70px] !rounded-full !bg-[#FFEDCC] !flex items-center justify-center" >

                          <div className="!w-[40px] !h-[40px] loader" ></div>
                        </div>
                     
                      </div>
                    </Card>
                  </Col>
                  <Col xs={24} md={12} lg={18} className="!bg-white">
                    <Row className="!flex !w-full items-center !h-full">
                      <Col xs={24}>
                        <Row>
                          <Col xs={24} md={10}>
                            <Row gutter={[20, 0]}>
                              <Col xs={24} lg={10}>
                                <Row gutter={[0, 5]}>
                                  <Col xs={24} className="!flex items-center gap-1">
                                    <Skeleton.Input active size="small" style={{ width: 120 }} />
                                  </Col>
                                  <Col xs={24} className="!flex items-center">
                                    <Skeleton.Input active size="small" style={{ width: 80 }} />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                          <Col xs={24} md={14}>
                            <Row gutter={[5, 0]}>
                              <Col xs={24} lg={8} className="!flex items-center">
                                <Skeleton.Input active size="small" style={{ width: 100 }} />
                              </Col>
                              <Col xs={24} lg={8} className="!flex items-center">
                                <Skeleton.Input active size="small" style={{ width: 100 }} />
                              </Col>
                              <Col xs={24} lg={8} className="!flex items-center">
                                <Skeleton.Input active size="small" style={{ width: 100 }} />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={24}>
                        <Row>
                          <Col xs={24} lg={12} className="!flex items-center gap-6">
                            <div className="!flex items-center gap-1">
                              <Avatar size="large" shape="circle" />
                              <div>
                                <Skeleton.Input active size="small" style={{ width: 120 }} />
                                <div>
                                  <Skeleton.Input active size="small" style={{ width: 80 }} />
                                </div>
                              </div>
                            </div>
                            <div className="!flex gap-3">
                              <span className="hover:cursor-pointer !flex gap-1 !py-2 px-4 border border-gray-300 !rounded-md transition items-center">
                                <Skeleton.Button active size="small" shape="round" />
                              </span>
                              <span className="hover:cursor-pointer !flex gap-1 !py-2 px-4 border border-gray-300 !rounded-md transition items-center">
                                <Skeleton.Button active size="small" shape="round" />
                              </span>
                            </div>
                          </Col>
                          <Col xs={24} lg={12} className="!flex justify-end items-center gap-4">
                            <Skeleton.Input active size="small" style={{ width: 100 }} />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      ))}
    </>
  );
};

export default AdvertListViewSkelton;